function revealProduts() {
  $('.shop-room .image-holder .btn').on('click', function(e) {
    e.preventDefault();
    const $this = $(this);
    const altText = $this.data('alt-text');
    const origText = $this.data('orig-text');
    $this.toggleClass('clicked');
    $this.closest('.shop-room').find('.product-listing').stop().slideToggle();
    $this.text(($this.hasClass('clicked') ? altText : origText ));
  })
}

export default revealProduts();



// WEBPACK FOOTER //
// ../markup/assets/js/shop-room.js